module.exports = __webpack_public_path__ + "static/media/seguradora_azos.7ef1c55d.png";